import React, { useEffect } from "react";
import { useSocket } from "../../../hooks/useSocket";
import useUserStore from "../../../stores/store";
import { getFormatedOrderList } from "../../../services/order-details-service";
import useOrderStore from "../../../stores/useOrderStore";
import { getOrderDefaultFilter } from "../../../utils/store.helper";
import { useNotificationSound } from "../../../hooks/usePlayNotificationSound";

const OrderEventReceiverSocket = ({}) => {
  const socket = useSocket(`${process.env.REACT_APP_IMAGE_BASE_URL}`);
  const { restaurantSlug } = useUserStore();
  const {
    setNewOrderId,
    prependOrderRecord,
    updateOrderRecord,
    setOrderRecords,
    setDashboardOrders,
    setShouldFetchOrderRecords,
    setShouldFetchDashboardOrders,
    setOrderRecordsFilter,
  } = useOrderStore();

  const playSound = useNotificationSound();

  useEffect(() => {
    setNewOrderId('');
    setShouldFetchOrderRecords(true);
    setShouldFetchDashboardOrders(true);
    setOrderRecordsFilter(getOrderDefaultFilter());
    setOrderRecords([]);
    setDashboardOrders([]);
  }, []);

  useEffect(() => {
    if (!socket || !restaurantSlug) {
      return;
    }

    // New Order Placed
    const eventName = `${restaurantSlug}-order-list-item-v2`;
    socket.on(eventName, (data) => {
      console.log(`Event ${eventName} received in OrderEventReceiverSocket---data:`, {
        time: Date.now(),
        data
      });
      
      const formatedRecord = getFormatedOrderList(data.record);

      if (data.isNewOrder) {
        prependOrderRecord(formatedRecord);
        setNewOrderId(formatedRecord._id);
        playSound();
      } else {
        updateOrderRecord(formatedRecord);
      }
    });
  }, [socket, restaurantSlug]);

  return <></>;
};

export default OrderEventReceiverSocket;
